export class IndependentPermissions {
    public OBS_Admin: boolean = false;
    public OBS_Admin_Unit: boolean = false;
    public ACT_Admin: boolean = false;
    public ACT_Admin_Unit: boolean = false;
    public INC_Admin: boolean = false;
    public INC_Admin_Unit: boolean = false;
    public RSK_Admin: boolean = false;
    public RSK_Admin_Unit: boolean = false;
    public INSP_Admin: boolean = false;
    public INSP_Admin_Unit: boolean = false;
    public ACT_Add: boolean = false;
    public ACT_Add_Unit: boolean = false;
    public INC_Add: boolean = false;
    public INC_Add_Unit: boolean = false;
    public OBS_Add: boolean = false;
    public OBS_Add_Unit: boolean = false;
    public RSK_Add: boolean = false;
    public RSK_Add_Unit: boolean = false;
    public INSP_Add: boolean = false;
    public INSP_Add_Unit: boolean = false;
    public OBS_View_Observer: boolean = false;
    public APP_Admin: boolean = false;
    public HSE_Admin: boolean = false;
    public SUPER_Admin: boolean = false;
}